import {
  PATH_STRING_SEPARATOR
} from '../../../common/config.js';

require('./plan-editor.component.scss');

export class PlanEditorController {
  constructor(
    $scope,
    $rootScope,
    $modalInstance,
    $modal,
    globalAlert,
    ErrorHandlerService,
    CurrentModelService,
    $http,
    $window,
    $timeout,
    $cookies,
    $httpParamSerializer,
  ) {
    this.$httpParamSerializer = $httpParamSerializer;
    this.$cookies = $cookies;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.$timeout = $timeout;
    this.$modal = $modal;
    this.$modalInstance = $modalInstance;
    this.globalAlert = globalAlert;
    this.$http = $http;
    this.window = angular.element($window);
    this.scope.currentPlan = null;
    this.scope.k = 1.0;
    this.scope.currentPoint = null;
    this.scope.error = null;
    this.scope.pointD = selected => {
      return selected ? this.scope.k * 20.0 - 2 : this.scope.k * 20.0;
    };


    this.getPlans();

    this.window.bind('resize', () => {
      const listBody = document.querySelector('.plan-body>div');
      $('.plan-body').height((window.innerHeight * 0.96 -
        $('.modal-header').outerHeight() -
        $('.list-head').outerHeight() -
        $('.modal-footer').outerHeight()));
      if (listBody) $('.toolbar-color>div').innerWidth(listBody.clientWidth);
    });

    this.scope.cancel = () => {
      if (this.scope.currentPlan) {
        this.scope.selectPlan(null);
      } else {
        $modalInstance.dismiss('cancel');
      }
    };
    this.scope.points = [];

    this.scope.onDblClick = e => {
      const p = {
        x: e.offsetX / this.scope.k - this.scope.pointD() / 2.0,
        y: e.offsetY / this.scope.k - this.scope.pointD() / 2.0,
        value: '',
        label: '',
        changed: true,
      };
      this.scope.currentPoint = p;
      this.scope.points.push(p);
    };

    this.deselectPoints = () => {
      if (!this.selected) return;
      this.scope.points.map(p => {
        if (p.selected) p.selected = false;
      });
    };

    this.scope.onMDown = e => {
      if (e.target.classList.contains('current-plan-img')) {
        this.scope.currentPoint = null;
        if (!e.shiftKey) {
          this.deselectPoints();
        }
        this.onDown = true;
        this.x = e.pageX;
        this.y = e.pageY;
        e.stopPropagation();
        e.preventDefault();
      }
    };

    this.scope.onMPointDown = (e, p) => {
      this.x = e.pageX;
      this.y = e.pageY;
      if (!e.shiftKey && !p.selected) {
        this.deselectPoints();
      }
      p.changed = true;
      this.scope.currentPoint = p;
      p.selected = true;
      this.onPointDown = true;
      e.stopPropagation();
      e.preventDefault();
    };

    this.window.bind('mouseup', e => {
      this.onDown = false;
      this.onPointDown = false;
    });

    this.window.keydown(e => {
      if (e.keyCode == 46 && this.selected) {
        this.scope.points = this.scope.points.filter(p => {
          if (p.selected) {
            if (p.id) {
              p.changed = true;
              p.deleted = true;
              return true;
            } else return false;
          } else return true;
        });
        this.scope.currentPoint = null;
        this.scope.$digest();
      }
    });

    this.scope.onMMove = e => {
      if (this.onDown) {
        this.planContainer.scrollBy(this.x - e.pageX, this.y - e.pageY);
        this.x = e.pageX;
        this.y = e.pageY;
      } else if (this.onPointDown) {
        this.scope.points.filter(p => p.selected).map(p => {
          p.x -= (this.x - e.pageX) / this.scope.k;
          p.y -= (this.y - e.pageY) / this.scope.k;
        });
        this.x = e.pageX;
        this.y = e.pageY;
      }
    };

    this.scope.savePoints = () => {
      this.savePoints();
    };

    this.scope.selectPlan = plan => {
      this.scope.points = [];
      this.scope.error = null;
      if (plan) this.getPlan(plan.id);
      else this.scope.currentPlan = null;

    };

    this.scope.increase = val => {
      const k = val / 100.0 + 1;
      this.scope.k *= k;
      this.currentPlanImg.style.width = `${this.currentPlanImg.clientWidth * k}px`;
      this.currentPlanImg.style.height = `${this.currentPlanImg.clientHeight * k}px`;
    };

    this.scope.selectPoint = p => {
      this.scope.currentPoint = p;
    };
  }

  get selected() {
    return this.scope.points.filter(p => p.selected).length;
  }

  get planContainer() {
    if (!this._planContainer) {
      this._planContainer = document.querySelector('div.current-plan');
    }
    return this._planContainer;
  }

  get currentPlanImg() {
    if (!this._currentPlanImg) {
      this._currentPlanImg = this.planContainer.querySelector('div.current-plan-img');
    }
    return this._currentPlanImg;
  }


  getPlan(id) {
    this.scope.k = 1.0;
    if (this.currentPlanImg.style.width) {
      this.currentPlanImg.style.width = 'auto';
      this.currentPlanImg.style.height = 'auto';
    }
    this.$http.get(`/plan/plans/${id}`)
      .then(({
        data,
        status,
      }) => {
        this.scope.currentPlan = data.plan;
        this.$timeout(() => {
          this.currentPlanImg.style.width = `${this.currentPlanImg.clientWidth}px`;
          this.currentPlanImg.style.height = `${this.currentPlanImg.clientHeight}px`;
        }, 100);
        this.scope.points = data.points;
      });
  }

  getPlans() {
    this.scope.k = 1.0;
    this.$http.get('/plan/plans/')
      .then(({
        data,
        status,
      }) => {
        this.scope.plans = data;
      });
  }

  savePoints() {
    const params = {
      points: this.scope.points.filter(p => p.value && p.changed)
    };
    if (!params.points.length) return this.scope.selectPlan(null);
    this.$http.post(`/plan/plans/${this.scope.currentPlan.id}/save/`, params, {
        headers: {
          'Accept': 'application/json;charset=utf-8',
          'X-CSRFToken': this.$cookies.get('csrftoken'),
          'Content-Type': 'application/json'
        },
      })
      .then(({
        data,
        status,
      }) => {
        if (data.error) this.scope.error = data.error;
        else this.scope.selectPlan(null);

      });
  }

}



// WEBPACK FOOTER //
// ./src/filter/editor/plan-editor/plan-editor.component.js